import { EventEmitter } from 'events';
import { FeatureCollection, LineString } from 'geojson';
import RoadNetLoader from '../loaders/RoadNetLoader';

const roadNetLoader = new RoadNetLoader();

export default class RoadNetGeoJSONProcessor extends EventEmitter implements IFileProcessor {
  public process(file: File) {
    const reader = new FileReader();
    reader.onload = () => {
      try {
        const data = JSON.parse(reader.result) as FeatureCollection<LineString>;
        data.features.forEach(feature => {
          roadNetLoader.addLineString(feature.geometry.coordinates as ILngLat[]);
        });
      } catch (err) {
        this.emit('error', err);
      }
    };
    reader.readAsText(file);
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/classes/processors/RoadNetGeoJSONProcessor.ts